<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center"><h1>Отправка сообщений</h1></div>
    </v-app-bar>
    <v-main>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-text-field
                v-model="title"
                label="Название"
                outlined
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                v-model="categorySelect"
                :items="categorys"
                item-text="NAME"
                item-value="ID"
                label="Воронка"
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="stageSelect"
                :items="stages"
                item-text="NAME"
                item-value="STATUS_ID"
                label="Стадия сделки"
                outlined
                multiple
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dates"
                    label="Дата создания"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  range
                  locale="ru-RU"
                  :first-day-of-week="1"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Отмена
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(dates)">
                    Сохранить
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                v-model="city"
                label="Город"
                outlined
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                v-model="assignedSelect"
                :items="assigneds"
                item-text="NAME"
                item-value="ID"
                label="Ответственный"
                outlined
                multiple
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="sourceSelect"
                :items="source"
                item-text="NAME"
                item-value="STATUS_ID"
                label="Источник"
                outlined
                multiple
              ></v-select>
            </v-col>
          </v-row>
          <v-btn
            color="success"
            class="mr-4"
            @click="getDeal"
            :disabled="loading"
          >
            Сформировать
          </v-btn>
          <v-btn
            color="orange"
            class="mr-4"
            @click="sendMail"
            :disabled="loading || contacts.length <= 0"
          >
            Отправить сообщения
          </v-btn>
        </v-container>
      </v-form>
      <template v-if="loading === true">
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          top
          color="light-green darken-4"
          height="10"
        ></v-progress-linear>
      </template>
      <template v-if="contacts.length > 0">
        <v-form>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="6">
                <v-textarea
                  v-model="sendText"
                  label="Текст сообщения"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <v-card v-if="contacts.length > 0">
        <v-data-table
          :headers="headers"
          :items="contacts"
          :items-per-page="5"
          class="elevation-1"
          no-data-text="Нет контактов"
          :footer-props="{
            'items-per-page-all-text': 'Все',
            'items-per-page-text': 'Контактов на стр.: ',
          }"
        >
          <template #[`item.actions`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";

export default {
  name: "App",
  data: () => ({
    loading: false,
    menu: false,
    title: "",
    city: "",
    dates: [],
    normalDate: [],
    source: [],
    sourceSelect: [],
    assigneds: [],
    assignedSelect: [],
    categorys: [],
    categorySelect: "",
    stages: [],
    stageSelect: [],
    parametrs: [],
    sendText: "",
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "ID", value: "id" },
      { text: "ФИО", value: "name" },
      { text: "Телефон", value: "phone" },
    ],
    contacts: [],
    url: "https://dcoffee.bitrix24.ru/rest/10991/ljc1vj4mzg7sv7tp/",
    urlBX: "",
    auth: {},
    domen: "",
  }),
  methods: {
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async normalizeDate() {
      try {
        if (this.dates[0]) {
          const firstDate = this.dates[0].split("-");
          const firstDateFormated =
            firstDate[2] +
            "." +
            firstDate[1] +
            "." +
            firstDate[0] +
            " 00:00:00";
          this.normalDate.push(firstDateFormated);
        }
        if (this.dates[1]) {
          const twoDate = this.dates[1].split("-");
          const twoDateFormated =
            twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          this.normalDate.push(twoDateFormated);
        }
      } catch (e) {
        console.log(e);
      }
    },
    deleteItem(item) {
      //console.log({item})
      const deletIndex = this.contacts.indexOf(item);
      this.contacts.splice(deletIndex, 1);
    },
    async getDeal() {
      try {
        this.loading = true;
        this.contacts = [];

        const paramsGetDeals = {
          filter: {},
          select: ["ID"],
        };
        if (this.categorySelect) {
          if (this.categorySelect)
            paramsGetDeals.filter["CATEGORY_ID"] = this.categorySelect;
          if (this.stageSelect.length > 0)
            paramsGetDeals.filter["STAGE_ID"] = this.stageSelect;
        }
        if (this.title) paramsGetDeals.filter["%TITLE"] = this.title;
        if (this.sourceSelect.length > 0)
          paramsGetDeals.filter["SOURCE_ID"] = this.sourceSelect;
        if (this.dates.length > 0) {
          await this.normalizeDate();
          if (this.normalDate[0])
            paramsGetDeals.filter[">=DATE_CREATE"] = this.normalDate[0];
          if (this.normalDate[1])
            paramsGetDeals.filter["<=DATE_CREATE"] = this.normalDate[1];
        }
        if (this.assignedSelect.length > 0)
          paramsGetDeals.filter["ASSIGNED_BY_ID"] = this.assignedSelect;
        if (this.city)
          paramsGetDeals.filter["UF_CRM_5D49690A481D2"] = this.city;

        const dealsData = await axios.post(
          this.url + "crm.deal.list",
          paramsGetDeals
        );
        const totalDeals = dealsData.data.total;
        const deals = [];
        let index = 0;
        const batchParamsDeals = {
          halt: 0,
          cmd: {},
        };
        for (let start = 0; start <= totalDeals + 50; start += 50) {
          console.log({ start });
          let methodRow = `crm.deal.list?select[0]=ID&start=${start}`;
          if (this.categorySelect) {
            if (this.categorySelect)
              methodRow += `filter[CATEGORY_ID]=${this.categorySelect}&`;
            if (this.stageSelect.length > 0) {
              for (const stageIndex in this.stageSelect) {
                methodRow += `filter[STAGE_ID][${stageIndex}]=${this.stageSelect[stageIndex]}&`;
              }
            }
          }
          if (this.title) methodRow += `filter[%TITLE]=${this.title}&`;
          if (this.sourceSelect.length > 0) {
            for (const sourceIndex in this.sourceSelect) {
              methodRow += `filter[SOURCE_ID][${sourceIndex}]=${this.sourceSelect[sourceIndex]}&`;
            }
          }
          if (this.dates.length > 0) {
            if (this.normalDate[0])
              methodRow += `filter[>=DATE_CREATE]=${this.normalDate[0]}&`;
            if (this.normalDate[1])
              methodRow += `filter[<=DATE_CREATE]=${this.normalDate[1]}&`;
          }
          if (this.assignedSelect.length > 0) {
            for (const assignedIndex in this.assignedSelect) {
              methodRow += `filter[ASSIGNED_BY_ID][${assignedIndex}]=${this.assignedSelect[assignedIndex]}&`;
            }
          }
          if (this.city)
            methodRow += `filter[UF_CRM_5D49690A481D2]=${this.city}&`;
          batchParamsDeals.cmd[`getDeals_${index}`] = methodRow;
          index += 1;
          if (Number(index) % 50 == 0 || Number(start) >= Number(totalDeals)) {
            const batchResultDeals = await axios.post(
              this.url + "batch",
              batchParamsDeals
            );
            for (const batchIndexDeals in batchResultDeals.data.result.result) {
              deals.push(
                ...batchResultDeals.data.result.result[batchIndexDeals]
              );
            }
            batchParamsDeals.cmd = {};
          }
        }
        //get contacts
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        const contacts = [];

        for (const index in deals) {
          batchParams.cmd[
            `getContact_${index}`
          ] = `crm.deal.contact.items.get?id=${deals[index].ID}`;
          if (index % 50 == 0 || Number(index) + 1 == deals.length) {
            const batchResult = await axios.post(
              this.url + "batch",
              batchParams
            );
            for (const batchIndex in batchResult.data.result.result) {
              contacts.push(...batchResult.data.result.result[batchIndex]);
            }
            batchParams.cmd = {};
          }
          await this.pause(10);
        }
        console.log({ contacts });
        for (const index in contacts) {
          batchParams.cmd[
            `contact_${index}`
          ] = `crm.contact.get?id=${contacts[index].CONTACT_ID}`;
          if (index % 50 == 0 || Number(index) + 1 == contacts.length) {
            const batchResult = await axios.post(
              this.url + "batch",
              batchParams
            );
            for (const batchIndex in batchResult.data.result.result) {
              if (batchResult.data.result.result[batchIndex].PHONE) {
                const indexContact = this.contacts.findIndex(
                  (e) => e.id == batchResult.data.result.result[batchIndex].ID
                );
                if (indexContact < 0) {
                  this.contacts.push({
                    id: batchResult.data.result.result[batchIndex].ID,
                    name: `
                  ${
                    batchResult.data.result.result[batchIndex].LAST_NAME
                      ? batchResult.data.result.result[batchIndex].LAST_NAME
                      : ""
                  } ${
                      batchResult.data.result.result[batchIndex].NAME
                        ? batchResult.data.result.result[batchIndex].NAME
                        : ""
                    } ${
                      batchResult.data.result.result[batchIndex].SECOND_NAME
                        ? batchResult.data.result.result[batchIndex].SECOND_NAME
                        : ""
                    }`,
                    phone:
                      batchResult.data.result.result[batchIndex].PHONE[0].VALUE,
                  });
                }
              }
            }
            batchParams.cmd = {};
          }
          await this.pause(50);
        }
        console.log(this.contacts);
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    async sendMail() {
      try {
        this.loading = true;
        //console.log(this.sendText)
        //console.log(this.senderSelect)
        //console.log(this.deals)
        for (const contact of this.contacts) {
          const methodSend = "bizproc.workflow.start";
          const paramsSend = {
            TEMPLATE_ID: 615,
            DOCUMENT_ID: ["crm", "CCrmDocumentContact", contact.id],
            PARAMETERS: {
              text: this.sendText,
            },
            auth: this.auth.ACCESS_TOKEN,
          };
          const resultSend = await axios.post(
            this.urlBX + methodSend,
            paramsSend
          );
          console.log({ resultSend });
          await this.pause(200);
        }
        console.log("SEND END");
        await window.location.reload();
      } catch (e) {
        console.log(e);
      }
    },
    async getFields() {
      try {
        console.log("getFields");
        //crm.category.list
        const categoryData = await axios.post(
          this.url + "crm.dealcategory.list",
          {}
        );
        console.log(categoryData);
        this.categorys = categoryData.data.result;
        //get source list
        const sourceData = await axios.post(
          this.url + "crm.status.entity.items",
          { entityId: "SOURCE" }
        );
        console.log(sourceData);
        this.source = sourceData.data.result;
        //get assigned
        const assignedData = await axios.post(this.url + "user.get", {
          ACTIVE: "Y",
        });
        console.log(assignedData);
        for (const user of assignedData.data.result) {
          this.assigneds.push({
            NAME: `${user.LAST_NAME} ${user.NAME} `,
            ID: user.ID,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getStages() {
      //crm.status.list
      const statusData = await axios.post(this.url + "crm.status.list", {
        //ENTITY_ID: "STATUS",
        filter: {
          CATEGORY_ID: this.categorySelect,
        },
      });
      this.stages = statusData.data.result;
      console.log({ statusData });
    },
  },
  watch: {
    categorySelect(oldData, newData) {
      if (oldData != newData) {
        this.getStages();
      }
    },
  },
  async mounted() {
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    this.urlBX = `https://${this.auth.DOMAIN}/rest/`;
    this.domen = this.auth.DOMAIN;

    await this.getFields();
  },
};
</script>
